export default __webpack_public_path__ + "static/logo-freshcells-systems-engineering-large-fde105a9bac6987d95a1032d384fd02a.png";